import obelisk from '../clients/obelisk';
import configs from '../config/app';

export const TranslationsCacheService = async (localeCode = 'en') =>
  (await obelisk()
    .setHeader('API-Key', configs.obeliskApiAuthKey)
    .get(`Translations/GetTranslationFile?shortcode=${localeCode}`)
    .then((r) => r?.data)) || {};
